"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateFormatterMixin = void 0;
const moment_timezone_1 = __importDefault(require("moment-timezone"));
class DateFormatterMixin {
    getDate(date) {
        return (0, moment_timezone_1.default)(date, "YYYY-MM-DD").startOf("day");
    }
    getDateTime(datetime) {
        return (0, moment_timezone_1.default)(datetime);
    }
    extractTimeFormat(time) {
        const timeFormatRegExp = /^((1[0-2]|0?[1-9]):([0-5][0-9]) ?([AaPp][Mm]))$/; // AM/PM
        return timeFormatRegExp.test(time) ? "h:mm A" : "HH:mm:ss";
    }
    getTime(time, format = "HH:mm:ss") {
        return moment_timezone_1.default.tz(time, format, "utc");
    }
    getDateFormat(dateFormat) {
        switch ((dateFormat || "")
            .toLowerCase()
            .replace(/[ /\\-]+/g, "")
            .replace(/ +/g, "")
            .replace(/y+/g, "y")
            .replace(/n+/g, "m")
            .replace(/m+/g, "m")
            .replace(/d+/g, "d")) {
            case "dmy":
                dateFormat = "D MMM YYYY";
                break;
            case "dym":
                dateFormat = "D YYYY MMM";
                break;
            case "mdy":
                dateFormat = "MMM D YYYY";
                break;
            case "myd":
                dateFormat = "MMM YYYY D";
                break;
            case "ydm":
                dateFormat = "YYYY D MMM";
                break;
            case "ymd":
                dateFormat = "YYYY MMM D";
                break;
            default:
                dateFormat = "MMM D YYYY";
        }
        return dateFormat;
    }
    getTimeFormat(timeFormat) {
        return timeFormat === "24h" ? "HH:mm" : "h:mm A";
    }
}
exports.DateFormatterMixin = DateFormatterMixin;
